export default __webpack_public_path__ + "c87e84eb3f97e3129e581dec6bf25ddd.png";